// Google Analytics 4 - Prepared but not activated
// Configure GA4_MEASUREMENT_ID in environment to activate

const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

// Check if consent was given
const hasConsent = () => {
  return localStorage.getItem('cookie_consent') === 'accepted';
};

// Initialize GA4 (called after consent)
export const initGA4 = () => {
  if (!GA4_MEASUREMENT_ID || !hasConsent()) {
    console.log('GA4: Not initialized (no ID or no consent)');
    return;
  }

  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: true,
  });

  console.log('GA4: Initialized with ID', GA4_MEASUREMENT_ID);
};

// Track page view
export const trackPageView = (pagePath, pageTitle) => {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle,
  });
};

// Track lead generation (form submit)
export const trackGenerateLead = (leadData) => {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', 'generate_lead', {
    currency: 'EUR',
    value: 1,
    company_name: leadData.company_name,
    sector: leadData.sector,
    quiz_score: leadData.quiz_score,
  });
};

// Track qualified lead
export const trackQualifyLead = (score) => {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', 'qualify_lead', {
    score: score,
  });
};

// Track disqualified lead
export const trackDisqualifyLead = (score) => {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', 'disqualify_lead', {
    score: score,
  });
};

// Track offer click
export const trackViewItem = (offerName, offerPrice) => {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', 'view_item', {
    currency: 'EUR',
    value: offerPrice,
    items: [
      {
        item_name: offerName,
        price: offerPrice,
      },
    ],
  });
};

// Track CTA click
export const trackCTAClick = (ctaName, ctaLocation) => {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', 'click', {
    event_category: 'CTA',
    event_label: ctaName,
    cta_location: ctaLocation,
  });
};

// Track quiz completion
export const trackQuizComplete = (score, qualified) => {
  if (!hasConsent() || !window.gtag) return;

  window.gtag('event', 'quiz_complete', {
    score: score,
    qualified: qualified,
  });

  // Also track qualification status
  if (qualified) {
    trackQualifyLead(score);
  } else {
    trackDisqualifyLead(score);
  }
};

export default {
  initGA4,
  trackPageView,
  trackGenerateLead,
  trackQualifyLead,
  trackDisqualifyLead,
  trackViewItem,
  trackCTAClick,
  trackQuizComplete,
};
